import { render, staticRenderFns } from "./AdminSet.vue?vue&type=template&id=3c903b63"
import script from "./AdminSet.vue?vue&type=script&lang=js"
export * from "./AdminSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports